// Put all packages together.
// Used to generate umd/index.prod.js

import React from 'react';
import { createRoot } from 'react-dom/client';

import { IntlProvider } from 'react-intl';

import allMessages from './messages.json';
import App from './app.jsx'

import '../css/base.min.css';
import "fomantic-ui-css/semantic.min.css";

import { CHAT_URL, TARGET, VERSION } from "./config";
console.info("-------------------------------------");
console.info(CHAT_URL + " " + TARGET + " " + VERSION);
console.log("embedded player ready ...");
console.info("-------------------------------------");

let data = null;
let hash = "";
let id = "";
let streamName = "";
let hasChat = false;
let chatURL = CHAT_URL || "ms-chat.member-streaming.live";
let tz = "";
let embedWidthAttr = null;
let embedHeightAttr = null;

function insertAfter(referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

if (typeof d !== 'undefined') {
  let streamInfo = JSON.parse(atob(d));
  id = streamInfo.p;
  hash = streamInfo.f;
  data = atob(hash);
  streamName = streamInfo.s;
  let dataSplit = data.split("::");
  hasChat = dataSplit[5] == 1;
  let script = document.getElementById('iframe');
} else {
  embedWidthAttr = document.currentScript.getAttribute('width');
  embedHeightAttr = document.currentScript.getAttribute('height');
  let width = embedWidthAttr ? embedWidthAttr + 'px' : '100%';
  let height = embedHeightAttr ? embedHeightAttr + 'px' : '100%';
  id = document.currentScript.getAttribute('data-stream');
  hash = document.currentScript.getAttribute('data-inline');
  data = atob(hash);
  streamName = document.currentScript.getAttribute('data-stream-name');
  let dataSplit = data.split("::");
  hasChat = dataSplit[5] == 1;

  let viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) {
    viewport = document.createElement('meta');
    viewport.name = 'viewport';
    viewport.content = 'width=device-width, initial-scale=1, viewport-fit=cover';
    document.head.appendChild(viewport);
  }

  let reCaptcha = document.createElement("script");
  reCaptcha.src = "https://www.google.com/recaptcha/api.js?render=explicit";
  reCaptcha.async = true;
  reCaptcha.defer = true;

  let mountPoint = document.createElement("div");
  mountPoint.id = 'emb-mountPoint';
  mountPoint.style.width = '100%';
  mountPoint.style.height = '100%';
  mountPoint.style.minHeight = '0';

  let content = document.createElement("div");
  content.id = 'emb-content';
  content.className = 'emb-site-content mms--streaming--content'
  content.style.maxWidth = width;
  content.style.width = '100%';
  content.style.margin = '0 auto';
  if (embedWidthAttr && embedHeightAttr) {
    content.style.aspectRatio = `${embedWidthAttr} / ${embedHeightAttr}`;
    content.style.height = 'auto';
  } else {
    content.style.height = height;
    content.style.aspectRatio = '16 / 9';
  }
  content.appendChild(mountPoint);

  let title = document.getElementsByTagName("title");
  title.text = streamName;

  insertAfter(document.currentScript, reCaptcha);
  insertAfter(document.currentScript, content);

  function isShortLandscape() {
    return window.innerWidth > window.innerHeight && window.innerHeight <= 500;
  }

  function applyEmbedAspectRatio(contentEl) {
    if (!contentEl || isShortLandscape()) {
      return;
    }
    if (embedWidthAttr && embedHeightAttr) {
      contentEl.style.aspectRatio = `${embedWidthAttr} / ${embedHeightAttr}`;
      contentEl.style.height = 'auto';
      contentEl.style.maxHeight = '';
    } else {
      contentEl.style.aspectRatio = '16 / 9';
      contentEl.style.height = 'auto';
      contentEl.style.maxHeight = '';
    }
  }

  function updateEmbedOrientation() {
    const contentEl = document.getElementById('emb-content');
    if (!contentEl) {
      return;
    }

    const landscape = isShortLandscape();
    contentEl.classList.toggle('emb-landscape', landscape);

    if (landscape) {
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      contentEl.style.aspectRatio = 'auto';
      contentEl.style.height = `${Math.round(viewportHeight)}px`;
      contentEl.style.maxHeight = `${Math.round(viewportHeight)}px`;
    } else {
      applyEmbedAspectRatio(contentEl);
    }
  }

  window.addEventListener('resize', updateEmbedOrientation);
  window.addEventListener('orientationchange', () => {
    setTimeout(updateEmbedOrientation, 150);
  });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateEmbedOrientation);
  }
  updateEmbedOrientation();

  // console.log('--->', width, height, id, data, streamName);
}


let streamElement = document.querySelector('[data-stream-data]');
if (streamElement.dataset['streamData']) {
  let stream_payload = JSON.parse(streamElement.dataset['streamData']);
  tz = stream_payload.tz;
}

let mountPoint = document.getElementById('emb-mountPoint');

function addChatMobileClass(added = false) {
  const content = document.getElementById('emb-content');
  if (content) {
    content.classList.toggle('chatResponsive', added);
  }
  if (!mountPoint) {
    return;
  }
  mountPoint.classList.toggle('chatResponsive', added);
}

console.log(">>>>>>>>>>> initial <<<<<<<<<<<<<<<<<<<")

// Use createRoot instead of ReactDOM.render
createRoot(mountPoint).render(
    <IntlProvider locale="en" messages={allMessages.en} textComponent={React.Fragment}>
    <App
        width='100%'
        height='100%'
        id={id}
        hash={hash}
        data={data}
        timeZone={tz}
        streamName={streamName}
        embedded={true}
        hasChat={hasChat}
        chatMobileClass={addChatMobileClass}
        streamSource=''
        serverAddress={chatURL}
        serverSecure={true}
      />
    </IntlProvider>
);
